import React from "react";

export default function MySQL_UCASE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_UCASE</h1>
      <p>This is the MySQL_UCASE component generated from the SQL JSON.</p>
    </div>
  );
}
